import React, { useState } from "react";
import HourlyForecastPreview from "./HourlyForecastPreview";
import axios from "axios";

import "./HourlyForecast.css";

export default function HourlyForecast(props) {
  const [loaded, setloaded] = useState(false);
  const [forecast, setForecast] = useState(null);

  function handleForecastResponse(response) {
    setForecast(response.data);
    setloaded(true);
  }

  if (loaded && props.city === forecast.city.name) {
    return (
      <div className="HourlyForecast card">
        <div className="row">
          <HourlyForecastPreview data={forecast.list[0]} />
          <HourlyForecastPreview data={forecast.list[1]} />
          <HourlyForecastPreview data={forecast.list[2]} />
          <HourlyForecastPreview data={forecast.list[3]} />
          <HourlyForecastPreview data={forecast.list[4]} />
        </div>
      </div>
    );
  } else {
    let apiKey = "3699a6fe3348afa86b71f2515e86a04b";
    let url = `https://api.openweathermap.org/data/2.5/forecast?q=${props.city}&appid=${apiKey}&units=metric`;
    axios.get(url).then(handleForecastResponse);

    return null;
  }
}
